module.exports = __webpack_public_path__ + "static/media/icon-logo.6d1358ca.svg";